import React from 'react'
import { PropTypes } from 'prop-types'
import { flowRight } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'
import { Trans, useTranslation } from 'react-i18next'
import { withErrorBoundaryNoRender } from 'lib/errorBoundary'
import { getAdTitle } from 'lib/ad'
import { fetchPolicy } from 'lib/apolloFetchPolicy'
import { getVerticalLogo } from 'lib/images'
import { inflect } from 'lib/translate'
import { getVerticalUrl } from 'lib/utils/store/vehicle'
import { urlWithLangParam } from 'lib/helpers'

import Loading from 'components/Util/Loading'
import Link from 'components/Link'

import getInactiveAdMessage from 'graphql/ad/getInactiveAdMessage.gql'

import './inactive-ad-message.pcss'

const InactiveAdModal = ({ data, vertical }) => {
    const { t, i18n } = useTranslation(['vehicles', 'makeOffer'])
    const { loading, error, ad } = data

    const renderContent = () => {
        const verticalName = inflect(t, t(`vehicles:vertical.${vertical}.name`), 'pronoun')
        const verticalUrl = urlWithLangParam(getVerticalUrl(t, vertical), i18n.language)

        return (
            <div className="inactive-ad-message">
                <div className="inactive-ad-message__vertical-logo">
                    <Link to={verticalUrl} trackName="verticalLogo">
                        {getVerticalLogo(vertical)}
                    </Link>
                </div>
                <div className="inactive-ad-message__message">
                    <Trans i18nKey="makeOffer:inactiveAd.message">
                        Myynti-ilmoitus <b>{{ adTitle: getAdTitle(ad[vertical]) }}</b> ei ole enää aktiivinen. Sulje ilmoitus jatkaaksesi OmaNettix-palvelun käyttöä tai siirry tekemään uusi haku <Link to={verticalUrl} trackName="gotoVertical">{verticalName}</Link>.
                    </Trans>
                </div>
            </div>
        )
    }

    return (
        <Loading loading={loading} error={error}>
            {() => renderContent()}
        </Loading>
    )
}

InactiveAdModal.propTypes = {
    adId: PropTypes.string.isRequired,
}

export default flowRight(
    withErrorBoundaryNoRender,
    graphql(getInactiveAdMessage, {
        options: ({ adId, vertical }) => ({
            variables: {
                vertical: vertical,
                id: adId,
            },
            fetchPolicy: fetchPolicy.NETWORK_ONLY,
        }),
    }),
)(InactiveAdModal)
